import type { InteractionEnvelope } from '@/common/types/interaction';
import { EnvelopeStatus } from '../enums';

/**
 * Determine if there exists at least one envelope in an array of envelopes that's status is not in a completed state.
 * @param envelopes array of envelopes with statuses
 * @returns true if any envelope status equals `created`, `partiallySigned`, `sending`, or `sent`.
 */
export const isAnyEnvelopeNotCompleted = (
  envelopes: Pick<InteractionEnvelope, 'status'>[],
): boolean =>
  envelopes.some(
    (envelope) =>
      envelope.status === EnvelopeStatus.created ||
      envelope.status === EnvelopeStatus.partiallySigned ||
      envelope.status === EnvelopeStatus.sending ||
      envelope.status === EnvelopeStatus.sent ||
      envelope.status === EnvelopeStatus.notFinalized,
  );

/**
 * Determine if there exists at least one envelope in an array of envelopes that's status in a processing state.
 * @param envelopes array of envelopes with statuses
 * @returns true if any envelope status equals `sending`
 */
export const isAnyEnvelopeInProcessingState = (
  envelopes: Pick<InteractionEnvelope, 'status'>[],
): boolean =>
  envelopes.some((envelope) => envelope.status === EnvelopeStatus.sending);

export const isSentStatus = (status: string): boolean =>
  status === 'sent' ||
  status === 'sending' ||
  status === 'voided' ||
  status === 'declined' ||
  status === 'partiallySigned' ||
  status === 'notFinalized' ||
  status === 'completed' ||
  status === 'delivered';
